import { getAccommodations, getExtendedCourses } from "../../services/faculty/v1/faculty";
import { GET_STUDENT_ACCOMMODATIONS,  GET_EXTENDED_COURSES} from "./actionTypes";

export const getStudentAccommodations = (getAcknowledgementObject) => async (dispatch, getState) => {
  const state = getState();
  
  // Check if user is authenticated before making API call
  if (!state.demographics.issuerId) {
    return;
  }
  
  await  getAccommodations(getAcknowledgementObject)
    .then((response) => {
      dispatch({ type: GET_STUDENT_ACCOMMODATIONS, payload: response.data });
    })
    .catch((error) => {
      dispatch({ type: GET_STUDENT_ACCOMMODATIONS, payload: error.request });
    });
};

export const getExtendedCoursesForIrn = (irn) => async (dispatch, getState) => {
  const state = getState();
  
  // Check if user is authenticated before making API call
  if (!state.demographics.issuerId) {
    return;
  }
  
  await  getExtendedCourses(irn)
    .then((response) => {
      dispatch({ type: GET_EXTENDED_COURSES, payload: response.data });
    })
    .catch((error) => {
      dispatch({ type: GET_EXTENDED_COURSES, payload: error.request });
    });
};